module.exports = __webpack_public_path__ + "img/ctrl-bwecp-stub-mid-+.b245d584.svg";